export default "/_next/static/images/fcac4448d5d0f7a575b097ecdc910f78.jpg";